import { render, staticRenderFns } from "./ReturnBack.vue?vue&type=template&id=74dfcb03&scoped=true"
import script from "./ReturnBack.vue?vue&type=script&lang=js"
export * from "./ReturnBack.vue?vue&type=script&lang=js"
import style0 from "./ReturnBack.vue?vue&type=style&index=0&id=74dfcb03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfcb03",
  null
  
)

export default component.exports